module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo3m.311ea7bc.png";